<ion-header>
  <ion-toolbar>
    <div class="toolbar-container">
      <ion-buttons slot="start">
        <ion-back-button
          color="title"
          text=""
          defaultHref="clubs"
        ></ion-back-button>
      </ion-buttons>
      <ion-title
        class="toolbar-title"
        style="color: var(--ion-color-title)"
        *ngIf="groupDetails"
        >{{groupDetails.Group_name}}</ion-title
      >
      <div></div>
      <!--ion-buttons
        slot="end"
        (click)="saveClubChanges(groupDetails.group_id)"
        *ngIf="groupDetails.STATUS === 4"
      >
        <ion-button>{{'SAVE_CHANGES' | translate}}</ion-button>
      </ion-buttons-->
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-horizontal" overflow-scroll="true">
  <ion-list lines="none">
    <ion-item lines="none">
      <label for="avatar" class="image-center">
        <ion-avatar class="ion-avatar-img">
          <img
            *ngIf="groupDetails"
            class="img-avatar"
            src="{{groupDetails.LOGO}}"
            onerror="if (this.src != 'assets/images/logo-noletter.svg') this.src = 'assets/images/logo-noletter.svg';"
          />
        </ion-avatar>
      </label>
      <input
        style="display: none"
        accept="image/*"
        type="file"
        id="avatar"
        (change)="onFileChange($event)"
        #fileInput
      />
    </ion-item>

    <!--  <ion-card><!-->
    <ion-item *ngIf="groupDetails && groupDetails.STATUS === 1">
      <h2>{{'REQUEST_PENDING_TITLE' | translate}}</h2>
      <p class="ion-text-wrap">{{'REQUEST_PENDING_TEXT' | translate}}</p>
      <ion-buttons style="text-align: center">
        <button
          ion-button
          icon-right
          color="exme-red-light"
          (click)="cancelJoinRequest()"
        >
          {{'CANCEL_JOIN_REQUEST' | translate}}
          <ion-icon name="thumbs-down"></ion-icon>
        </button>
      </ion-buttons>
    </ion-item>
    <!--  </ion-card> <-->
    <!--    <ion-card> <-->
    <ion-item *ngIf="groupDetails && groupDetails.STATUS === 2">
      <h2>{{'INVITATION_PENDING_TITLE' | translate}}</h2>
      <p class="ion-text-wrap">{{'INVITATION_PENDING_TEXT' | translate}}</p>
      <ion-buttons style="text-align: center">
        <button ion-button icon-right (click)="memberAcceptInvitation()">
          {{'ACCEPT_INVITATION_REQUEST' | translate}}
          <ion-icon name="thumbs-up"></ion-icon>
        </button>
        <button
          ion-button
          icon-right
          color="exme-red-light"
          (click)="memberRefuseInvitation()"
        >
          {{'REJECT_INVITATION_REQUEST' | translate}}
          <ion-icon name="thumbs-down"></ion-icon>
        </button>
      </ion-buttons>
    </ion-item>
    <!--    </ion-card><-->

    <!--   <ion-card ><-->
    <ion-item *ngIf="groupDetails && groupDetails.STATUS === 4">
      <p></p>
      <ion-label class="ion-text-wrap">
        <h2 style="color: var(--ion-color-primary); font-size: 20px">
          {{'ADMIN_GROUP_TITLE' | translate}}
        </h2>
        <p>{{'ADMIN_GROUP_TEXT' | translate}}</p>
      </ion-label>
    </ion-item>

    <ion-item
      *ngIf="groupDetails && (groupDetails.STATUS === 3 || groupDetails.STATUS === 4)"
    >
      <ion-button
        expand="block"
        fill="solid"
        color="secondary"
        style="height: 45px; font-size: smaller; width: 100%"
        (click)="goToMessages()"
        ><b>{{'GROUP_MESSAGES_CHAT' | translate }}</b></ion-button
      >
      <!--ion-icon
        *ngIf="inGroup===true && groupDetails.last_read_message_in_group === groupDetails.max_message_in_group"
        name="chatbox"
        color="secondary"
        slot="end"
        (click)="goToMessages()"
      ></ion-icon>
      <ion-icon
        *ngIf="inGroup===true && groupDetails.last_read_message_in_group !== groupDetails.max_message_in_group"
        name="chatbox"
        color="exme-red-light"
        slot="end"
        (click)="goToMessages()"
      ></ion-icon-->
    </ion-item>

    <!--  </ion-card><-->

    <!--  <ion-card *ngIf="groupDetails.manager_agent_id === groupDetails.agent_id"><-->

    <ion-item *ngIf="groupDetails && groupDetails.STATUS === 4">
      <!--ion-item *ngIf="groupDetails.manager_agent_id === groupDetails.agent_id"-->
      <!-- <ion-label color="primary" style="font-size: 20px" position="stacked"
        >{{'GROUP_NAME' | translate}}</ion-label
      > -->
      <ion-input
        name="groupName"
        ngDefaultControl
        [(ngModel)]="groupDetails.Group_name"
        (ionInput)="onInputChange()"
        labelPlacement="stacked"
      >
        <div slot="label">
          <ion-text color="primary">{{'GROUP_NAME' | translate}}</ion-text>
        </div>
      </ion-input>
    </ion-item>
    <ion-item *ngIf="groupDetails && groupDetails.STATUS === 4">
      <!--ion-item *ngIf="groupDetails.manager_agent_id === groupDetails.agent_id"-->
      <!-- <ion-label color="primary" style="font-size: 20px" position="stacked"
        >{{'EDIT_ENTRY_DESC' | translate}}</ion-label
      > -->
      <ion-textarea
        name="groupDescription"
        ngDefaultControl
        [autoGrow]="true"
        [(ngModel)]="groupDetails.GROUP_DESCRIPTION"
        (ionInput)="onInputChange()"
        labelPlacement="stacked"
      >
        <div slot="label">
          <ion-text color="primary">{{'EDIT_ENTRY_DESC' | translate}}</ion-text>
        </div>
      </ion-textarea>
    </ion-item>
    <p></p>
    <!--ion-list *ngIf="groupDetails.manager_agent_id === groupDetails.agent_id" no-lines radio-group [(ngModel)]="groupDetails.group_type"-->
    <ion-list radio-button *ngIf="groupDetails && groupDetails.STATUS === 4">
      <ion-label
        class="ion-padding"
        color="primary"
        style="font-size: 20px"
        position="stacked"
        >{{'GROUP_TYPE' | translate}}</ion-label
      >
      <ion-radio-group
        [(ngModel)]="groupDetails.group_type"
        value="{groupDetails.group_type}"
        (ionChange)="radioBtnSave()"
      >
        <ion-item>
          <!-- <ion-label
            >{{'P' | translate}}<span
              ><p class="ion-text-wrap">{{'P_DESC' | translate}}</p></span
            ></ion-label
          > -->
          <ion-radio value="P" class="radio"
            ><div>
              {{'P' | translate}}<span
                ><p class="ion-text-wrap radio-text-small">
                  {{'P_DESC' | translate}}
                </p></span
              >
            </div></ion-radio
          >
        </ion-item>
        <ion-item>
          <!-- <ion-label
            >{{'C' | translate}}<span
              ><p class="ion-text-wrap">{{'C_DESC' | translate}}</p></span
            ></ion-label
          > -->
          <ion-radio value="C" class="radio"
            >{{'C' | translate}}<span
              ><p class="ion-text-wrap radio-text-small">
                {{'C_DESC' | translate}}
              </p></span
            ></ion-radio
          >
        </ion-item>
        <ion-item>
          <!-- <ion-label
            >{{'S' | translate}}<span
              ><p class="ion-text-wrap">{{'S_DESC' | translate}}</p></span
            ></ion-label
          > -->
          <ion-radio value="S" class="radio"
            >{{'S' | translate}}<span
              ><p class="ion-text-wrap radio-text-small">
                {{'S_DESC' | translate}}
              </p></span
            ></ion-radio
          >
        </ion-item>
      </ion-radio-group>
    </ion-list>
    <!-->  </ion-card> <-->

    <!-->  <ion-card *ngIf="groupDetails.manager_agent_id != groupDetails.agent_id"><-->
    <ion-item *ngIf="groupDetails && groupDetails.STATUS !== 4">
      <!--ion-item *ngIf="groupDetails.manager_agent_id != groupDetails.agent_id"-->
      <!-- <ion-label color="primary" style="font-size: 20px" position="stacked"
        >{{'GROUP_NAME' | translate}}</ion-label
      > -->
      <ion-input
        disabled="true"
        value="{{groupDetails.Group_name}}"
        labelPlacement="stacked"
      >
        <div slot="label">
          <ion-text color="primary">{{'GROUP_NAME' | translate}}</ion-text>
        </div>
      </ion-input>
    </ion-item>
    <ion-item *ngIf="groupDetails && groupDetails.STATUS !== 4">
      <!--ion-item *ngIf="groupDetails.manager_agent_id != groupDetails.agent_id"-->
      <!-- <ion-label color="primary" style="font-size: 20px" position="stacked"
        >{{'EDIT_ENTRY_DESC' | translate}}</ion-label
      > -->
      <ion-textarea
        disabled="true"
        [autoGrow]="true"
        value="{{groupDetails.GROUP_DESCRIPTION}}"
        labelPlacement="stacked"
      >
        <div slot="label">
          <ion-text color="primary">{{'EDIT_ENTRY_DESC' | translate}}</ion-text>
        </div>
      </ion-textarea>
    </ion-item>
    <!--ion-item *ngIf="groupDetails.manager_agent_id != groupDetails.agent_id">
      <ion-label color="primary" position="stacked">{{'ADMINISTRATOR' | translate}}</ion-label>
      <ion-input disabled="true" value="{{groupDetails.manager_agent_name}}"></ion-input>
    </ion-item-->
    <ion-item *ngIf="groupDetails && groupDetails.STATUS !== 4">
      <!--ion-item *ngIf="groupDetails.manager_agent_id != groupDetails.agent_id"-->
      <!-- <ion-label color="primary" style="font-size: 20px" position="stacked"
        >{{'GROUP_TYPE' | translate}}</ion-label
      > -->
      <ion-input
        disabled="true"
        value="{{groupDetails.group_type | translate}}"
        labelPlacement="stacked"
      >
        <div slot="label">
          <ion-text color="primary">{{'GROUP_TYPE' | translate}}</ion-text>
        </div>
      </ion-input>
    </ion-item>
    <ion-item *ngIf="groupDetails && groupDetails.STATUS !== 4">
      <!--ion-item *ngIf="groupDetails.manager_agent_id != groupDetails.agent_id"-->
      <ion-label *ngIf="groupDetails.group_type === 'P' " class="text"
        >{{'P_DESC' | translate}}</ion-label
      >
      <ion-label *ngIf="groupDetails.group_type === 'C' " class="text"
        >{{'C_DESC' | translate}}</ion-label
      >
      <ion-label *ngIf="groupDetails.group_type === 'S' " class="text"
        >{{'S_DESC' | translate}}</ion-label
      >
    </ion-item>
    <!-->  </ion-card> <-->

    <!-->   <ion-card><-->
    <ion-item ion-item>
      <ion-icon name="people" color="primary" slot="start" large></ion-icon>
      <ion-label class="ion-text-wrap">
        <h2 style="color: var(--ion-color-primary); font-size: 20px">
          {{'MEMBER_LIST' | translate}}
        </h2>
        <p *ngIf="groupDetails && groupDetails.STATUS === 4">
          {{'ADD_MEMBERS' | translate}}
        </p>
      </ion-label>
    </ion-item>

    <ion-list>
      <div *ngFor="let member of groupMembers">
        <ion-item
          ion-item
          *ngIf="member && member.STATUS > 0 "
          (click)="memberClick(member)"
        >
          <ion-avatar slot="start">
            <img
              *ngIf=" member.CRM_AGENT_by_AGENT_ID !== null"
              src="{{member.CRM_AGENT_by_AGENT_ID.AVATAR}}"
              onerror="if (this.src != 'assets/icon/noavatar.jpg') this.src = 'assets/icon/noavatar.jpg';"
            />
            <img
              *ngIf="member.CRM_AGENT_by_AGENT_ID === undefined"
              src="assets/icon/noavatar.jpg"
            />
            <div class="positioner" *ngIf="(member.is_favorite===1)">
              <ion-icon
                class="ribbon-icon"
                name="heart"
                color="highlight"
                slot="end"
              ></ion-icon>
            </div>
          </ion-avatar>
          <ion-note
            slot="end"
            *ngIf="member.CRM_AGENT_by_AGENT_ID.trade_by_mail"
          >
            <ion-icon name="mail" color="primary"></ion-icon>
          </ion-note>

          <ion-label>
            <h3 class="bold" *ngIf="member.CRM_AGENT_by_AGENT_ID !== null">
              {{member.CRM_AGENT_by_AGENT_ID.FIRST_NAME}}
              {{member.CRM_AGENT_by_AGENT_ID.LAST_NAME}}
            </h3>

            <ion-row>
              <ion-label style="vertical-align: text-top">
                <!--p>{{ 'CURRENT_TRADE_RATING' | translate }}</p-->
                <div>
                  <span *ngFor="let n of [0,1,2,3,4]">
                    <ion-icon
                      color="primary"
                      style="padding-right: 4px"
                      *ngIf="n < member.CRM_AGENT_by_AGENT_ID.trade_rating"
                      name="star"
                    ></ion-icon>
                    <ion-icon
                      color="primary"
                      style="padding-right: 4px"
                      *ngIf="n >= member.CRM_AGENT_by_AGENT_ID.trade_rating"
                      name="star-outline"
                    ></ion-icon>
                  </span>
                  <ion-text
                    ><sup
                      >({{member.CRM_AGENT_by_AGENT_ID.num_trade_evaluations}})</sup
                    ></ion-text
                  >
                </div>
              </ion-label>
            </ion-row>

            <p
              *ngIf="member.CRM_AGENT_by_AGENT_ID.preferred_location_1 !== null && member.CRM_AGENT_by_AGENT_ID.preferred_location_1 !== ''"
            >
              {{member.CRM_AGENT_by_AGENT_ID.preferred_location_1}}
              <span
                *ngIf="member.CRM_AGENT_by_AGENT_ID.preferred_location_2 !== null && member.CRM_AGENT_by_AGENT_ID.preferred_location_2 !== ''"
              >
                <ion-icon color="primary" name="add-circle"></ion-icon>
              </span>
            </p>

            <h2
              *ngIf="member.CRM_AGENT_by_AGENT_ID === null && groupDetails && groupDetails.STATUS === 4"
            >
              {{member.email}}
            </h2>
            <h2
              *ngIf="member.CRM_AGENT_by_AGENT_ID === null && groupDetails && (!(groupDetails.STATUS === 4))"
            >
              {{'MEMBER_PENDING_APPROVAL' | translate}}
            </h2>
            <h3 class="ion-text-wrap" *ngIf="member && member.STATUS === 1">
              <ion-icon color="danger" name="alert"></ion-icon>
              {{'PENDING_APPROVAL' | translate}}
            </h3>
            <h3 class="ion-text-wrap" *ngIf="member && member.STATUS === 2">
              <ion-icon color="danger" name="alert"></ion-icon>
              {{getInvitedEmail(member.email)}}
            </h3>
            <h3 class="ion-text-wrap" *ngIf="member && member.STATUS === 4">
              <ion-icon color="primary" name="settings"></ion-icon>
              {{'ADMIN' | translate}}
            </h3>
          </ion-label>
          <!--
         <ion-note slot="end">
           <ion-badge *ngIf="member.STATUS === 1" color="light">{{'PENDING_APPROVAL' | translate}}</ion-badge>
           <ion-badge *ngIf="member.STATUS === 2" color="light">{{'INVITED' | translate}}</ion-badge>
           <ion-badge *ngIf="member.STATUS === 3">{{'ACTIVE' | translate}}</ion-badge>
           <ion-badge *ngIf="member.STATUS === 4" color="secondary">{{'ADMIN' | translate}}</ion-badge>
         </ion-note>
       -->
        </ion-item>
      </div>
    </ion-list>
  </ion-list>
</ion-content>

<!--  </ion-card><-->
<!--
<ion-buttons  *ngIf="inGroup === true && groupDetails.STATUS === 4">
  <button ion-button icon-right color="exme-red-light" block (click)="deleteClub()">
    {{'DELETE_CLUB' | translate}}
    <ion-icon name="trash"></ion-icon>
  </button>
</ion-buttons>
-->

<!--
<ion-buttons *ngIf="inGroup === true">
-->
<!--ion-buttons *ngIf="groupDetails.STATUS === 3"-->
<!--
  <button ion-button icon-right color="exme-red-light" block (click)="abandonClub()">
    {{'ABANDON_CLUB' | translate}}
    <ion-icon name="exit"></ion-icon>
  </button>
</ion-buttons>
-->

<ion-fab
  horizontal="end"
  vertical="bottom"
  *ngIf="inGroup === true && groupDetails && groupDetails.STATUS !== 4"
>
  <ion-fab-button color="secondary" (click)="exitGroupAlert()">
    <ion-icon name="log-out"></ion-icon>
  </ion-fab-button>
</ion-fab>

<!--
<ion-fab *ngIf="groupDetails.STATUS === 4" right top>
  <button ion-fab mini (click)="inviteMembers(groupDetails.group_id, groupDetails.Group_name)">
    <ion-icon name="add"></ion-icon>
  </button>
</ion-fab>
-->

<ion-fab
  horizontal="end"
  vertical="bottom"
  *ngIf="groupDetails && groupDetails.STATUS === 4"
>
  <ion-fab-button color="secondary"
    ><ion-icon name="add"></ion-icon
  ></ion-fab-button>
  <ion-fab-list side="top">
    <ion-fab-button
      color="exmeYellowLight"
      (click)="inviteMembers(groupDetails.group_id, groupDetails.Group_name)"
      ><ion-icon name="person-add"></ion-icon
    ></ion-fab-button>
    <ion-fab-button color="exme-red-light" (click)="exitGroupAlert()"
      ><ion-icon name="log-out"></ion-icon
    ></ion-fab-button>
    <ion-fab-button color="exme-red" (click)="deleteClub()"
      ><ion-icon name="trash"></ion-icon
    ></ion-fab-button>
  </ion-fab-list>
</ion-fab>

<ion-footer *ngIf="inGroup === false">
  <ion-toolbar>
    <ion-buttons
      slot="end"
      *ngIf="inGroup === false && groupDetails.group_type === 'P'"
    >
      <ion-button
        color="secondary"
        expand="block"
        fill="solid"
        (click)="joinPublicGroup(groupDetails)"
      >
        <!--ion-buttons *ngIf="groupDetails.STATUS === 3"-->
        {{'JOIN_GROUP' | translate}}
        <!--ion-icon name="contacts"></ion-icon-->
      </ion-button>
    </ion-buttons>
    <ion-buttons
      slot="end"
      *ngIf="inGroup === false && groupDetails.group_type === 'C'"
    >
      <ion-button
        color="secondary"
        expand="block"
        fill="solid"
        (click)="joinPrivateGroup(groupDetails)"
      >
        <!--ion-buttons *ngIf="groupDetails.STATUS === 3"-->
        {{'JOIN_GROUP' | translate}}
        <!--ion-icon name="contacts"></ion-icon-->
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
